import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';

const ContactMap = ({ contactData }) => {

  const [plotData, setPlotData] = useState([]);

  useEffect(() => {
    // Step 1: Get unique sorted X and Y labels
    const xLabels = Array.from(new Set(contactData.map(d => d.anPosition))).sort((a, b) => a - b);
    const yLabels = Array.from(new Set(contactData.map(d => d.contactPosition))).sort((a, b) => a - b);

    // Step 2: Initialize a 2D matrix with nulls
    const zMatrix = yLabels.map(() =>
      xLabels.map(() => null)
    );


    // Step 3: Populate the zMatrix with distances
    contactData.forEach(({ anPosition, contactPosition, distance }) => {
      const xIndex = xLabels.indexOf(anPosition);
      const yIndex = yLabels.indexOf(contactPosition);
      if (xIndex !== -1 && yIndex !== -1 ) {
        zMatrix[yIndex][xIndex] = distance;
      }
    });

    // Step 4: Set the Plotly data
    setPlotData([
      {
        x: xLabels,
        y: yLabels,
        z: zMatrix,
        type: 'heatmap',
        hovertemplate: '(%{x}-%{y}) - distance %{z}Å',
        zmin: 0,
        zmax: 8,
        colorscale: [
          ['0.0', 'rgb(165,0,0)'],
          ['0.111111111111', 'rgb(215,48,0)'],
          ['0.222222222222', 'rgb(244,109,0)'],
          ['0.333333333333', 'rgb(253,174,0)'],
          ['0.444444444444', 'rgb(254,224,0)'],
          ['0.555555555556', 'rgb(224,243,0)'],
          ['0.666666666667', 'rgb(171,217,0)'],
          ['0.777777777778', 'rgb(116,173,0)'],
          ['0.888888888889', 'rgb(69,117,0)'],
          ['1.0', 'rgb(49,54,0)']
        ],
        hoverongaps: false,
        colorbar: {
          title: {
            text: 'Distance (Å)',
            side: 'right',
            font: {
              size: 10
            }
          }
        }
      }
    ]);
  }, [contactData]);


  const layout = {
    autosize: true,
     font: { size: 9 },
    title: {
          text: "Contacts Map",
        },
    xaxis: {
      type: 'category',
      automargin: true,
      title: { text: 'Residue Position' },
      scaleanchor: 'y',
    },
    yaxis: {
      type: 'category',
      automargin: true,
      title: { text: 'Residue Position' },
    },
    margin: { t: 40, b: 40, l: 40, r: 40 },
  };

  return (
    <div className="aspect-square card">
      <Plot
        data={plotData}
        layout={layout}
        useResizeHandler
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default ContactMap;
